import type React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './flight-stage-table.module.css';

const FlightStageTable: React.FC = () => {
  const [t] = useTranslation();

  const stageLabels = [
    'pages.regional_overview.digital_traps.flight_stage.out_of_season',
    'pages.regional_overview.digital_traps.flight_stage.beginning_of_the_flight',
    'pages.regional_overview.digital_traps.flight_stage.fast_growing_population',
    'pages.regional_overview.digital_traps.flight_stage.peak_of_the_flight',
    'pages.regional_overview.digital_traps.flight_stage.egg_deposition_peak',
    'pages.regional_overview.digital_traps.flight_stage.larval_hatching_peak',
    'pages.regional_overview.digital_traps.flight_stage.end_of_the_flight'
  ];

  return (
    <div className={styles.container} data-testid='flight-stage-table'>
      <div className={styles.tableContainer}>
        <div className={styles.firstColumn}>
          <div className={styles.generationCell}>G1</div>
          <div className={styles.generationCell}>G2</div>
          <div className={styles.generationCell}>G3</div>
        </div>
        {stageLabels.map(label => (
          <div key={label} className={styles.stageColumn}>
            <div className={styles.stageCell}>{t(label)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FlightStageTable;
